export const installationStatus = sensors => {
  const statusRed = sensors.find(s => s.status === 'red')
  if (statusRed) return 'red'
  const statusYellow = sensors.find(s => s.status === 'yellow')
  if (statusYellow) return 'yellow'
  const statusGreen = sensors.find(s => s.status === 'green')
  if (statusGreen) return 'green'
  return 'inactive'
}
